module.exports = __webpack_public_path__ + "static/img/3_5_2.9396bbc0.jpg";